import React, { useState, useContext, useEffect } from "react";
import "./requestCategoryModal.css";
import { CombinedContext } from "../../../context/combinedContext";
import companyBasedRequest from "../../../request/companyBasedRequest";
import translations from "../../../translations/translations";
import BannerMessageFixed from "../../common/bannerMessageFixed/bannerMessageFixed";

const RequestCategoryModal = ({ open, onClose, onSuggestionSubmit }) => {
    const { language } = useContext(CombinedContext);
    const [suggestion, setSuggestion] = useState("");
    const t = translations[language].listShop.requestCategoryModal;

    if (!open) return null;

    const handleSubmit = () => {
        if (!suggestion.trim()) return;
        onSuggestionSubmit(suggestion);
        onClose();
    };

    return (
        <div className="sf-rc-overlay" onClick={onClose}>
            <div className="sf-rc-modal" onClick={(e) => e.stopPropagation()}>
                <div className="sf-rc-header">
                    <h3 className="sf-rc-title">{t.title}</h3>
                    <button className="sf-rc-close" onClick={onClose}>✕</button>
                </div>
                <div className="sf-rc-body">
                    <p className="sf-rc-subtitle">{t.subtitle}</p>
                    <input className="sf-rc-input" placeholder={t.suggestionPlaceholder} value={suggestion} onChange={(e) => setSuggestion(e.target.value)} />
                </div>
                <div className="sf-rc-footer">
                    <button className="sf-rc-btn-cancel" onClick={onClose}>{t.cancel}</button>
                    <button className="sf-rc-btn-submit" onClick={handleSubmit}>{t.send}</button>
                </div>
            </div>
        </div>
    );
};

export default RequestCategoryModal;
